import {
  useContext,
} from '@nuxtjs/composition-api';
import { Location } from 'vue-router';

export const useNavigation = () => {
  const { $location } = useContext();

  const toChatLocation = (projectId: string, chatId: string): Location | null => {
    if (projectId) {
      return $location.toChatLocation({ projectId, chatId });
    }
    return null;
  };

  return {
    toChatLocation,
  };
};

export { default as ComponentNavigationPatient } from './Navigation.patient.vue';
export { default as ComponentNavigationDoctor } from './Navigation.doctor.vue';
